import { RJSFSchema } from "@rjsf/utils";

// groupInfoSchema, cobraAdminSchema, productsSoldSchema, enrollmentSchema, docUploadSchema

const stateList = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export const groupInfoSchema: RJSFSchema = {
  type: "object",
  properties: {
    groupName: {
      type: "string",
      title: "Group Name",
    },
    groupNumber: {
      type: "string",
      title: "Group Number",
    },
    submitterEmail: {
      type: "string",
      title: "Submitter Email",
    },
  },

  required: ["groupName", "submitterEmail"],
};

export const primaryInfoSchema: RJSFSchema = {
  type: "object",
  properties: {
    firstName: {
      type: "string",
      title: "First Name",
    },
    lastName: {
      type: "string",
      title: "Last Name",
    },
    dateOfBirth: {
      type: "string",
      format: "date",
      title: "Date of Birth",
    },
    gender: {
      type: "string",
      title: "Gender",
      enum: ["M", "F"],
    },
    ssn: {
      type: "string",
      title: "Social Security Number",
    },
    address1: {
      type: "string",
      title: "Street Address",
    },
    address2: {
      type: "string",
      title: "Street Address 2",
    },
    city: {
      type: "string",
      title: "City",
    },
    state: {
      type: "string",
      enum: stateList,
      title: "State",
    },
    zipCode: {
      type: "string",
      title: "Zip Code",
    },
    phoneNumber: {
      type: "string",
      title: "Phone Number",
    },
    email: {
      type: "string",
      title: "Email Address",
    },
  },

  required: ["firstName", "lastName", "dateOfBirth", "gender", "ssn", "address1", "city", "state", "zipCode"],
};

export const coverageSelectionSchema: RJSFSchema = {
  type: "object",
  properties: {
    planSelection: {
      type: "string",
      title: "Plan Selection",
    },
    effectiveDate: {
      type: "string",
      format: "date",
      title: "Effective Date",
    },
    coverageSelection: {
      type: "string",
      title: "Coverage Selection",
      enum: ["Employee Only", "Employee & Spouse", "Employee & Child(ren)", "Family"],
    },
  },

  required: ["planSelection", "coverageSelection"],
};

export const dependentInfoSchema: RJSFSchema = {
  definitions: {
    dependent: {
      type: "object",
      title: " ",
      properties: {
        firstName: {
          type: "string",
          title: "First Name",
        },
        lastName: {
          type: "string",
          title: "Last Name",
        },
        dateOfBirth: {
          type: "string",
          format: "date",
          title: "Date of Birth",
        },
        gender: {
          type: "string",
          title: "Gender",
          enum: ["M", "F"],
        },
        ssn: {
          type: "string",
          title: "Social Security Number",
        },
        relationship: {
          type: "string",
          title: "Relationship",
          enum: ["Spouse", "Child"],
        },
        useSameAddressAsPrimary: {
          type: "boolean",
          title: "Use same address as Primary?",
          default: true,
        },
      },
      required: ["firstName", "lastName", "dateOfBirth", "gender", "relationship"],
      dependencies: {
        useSameAddressAsPrimary: {
          oneOf: [
            { properties: { useSameAddressAsPrimary: { const: true } } },
            {
              properties: {
                useSameAddressAsPrimary: { const: false },

                address1: {
                  type: "string",
                  title: "Street Address",
                },
                address2: {
                  type: "string",
                  title: "Street Address 2",
                },
                city: {
                  type: "string",
                  title: "City",
                },
                state: {
                  type: "string",
                  enum: stateList,
                  title: "State",
                },
                zipCode: {
                  type: "string",
                  title: "Zip Code",
                },
              },
              required: ["address1", "city", "state", "zipCode"],
            },
          ],
        },
      },
    },
  },
  type: "object",
  properties: {
    dependents: {
      type: "array",
      title: "Dependents",
      minItems: 1,
      items: {
        $ref: "#/definitions/dependent",
      },
    },
  },

  required: [],
};
